import { Dialog } from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import Formulario from "./Formulario";
import { FormProvider, useForm } from "react-hook-form";
import DialogContentSelecionarCliente from "../../../../../components/DialogContentSelecionarCliente/indext";
import useMobileScreen from "../../../../../lib/useMobileScreen";
import { useCallback, useState } from "react";
import moment, { Moment } from "moment";
import { clienteDefValue } from "../../../../../types/api/geral/pesquisar-publicos";

export default function DialogAtualizacaoLimites({
  open,
  handleClose,
}: DialogAtualizacaoLimitesProps) {
  const telaMobile = useMobileScreen();

  const [modalContent, setModalContent] =
    useState<TModalContent>("selecionarCliente");

  const methods = useForm({ defaultValues: defaultValuesForm });
  const { getValues, setValue } = methods;

  //Funções Manipuladoras
  const handleConfirm = useCallback(() => {
    if (modalContent === "selecionarCliente") {
      setModalContent("criarAtualizacao");
    }
  }, [modalContent]);

  const handleBack = useCallback(() => {
    setModalContent("selecionarCliente");
  }, []);

  const onCloseModal = () => {
    handleClose();
  };
  //

  return (
    <Dialog
      open={open}
      onClose={onCloseModal}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      fullScreen={telaMobile}
      maxWidth={modalContent === "selecionarCliente" ? "sm" : "md"}
      scroll="body"
    >
      <FormProvider {...methods}>
        {modalContent === "selecionarCliente" && (
          <DialogContentSelecionarCliente
            {...{ handleClose }}
            retornarProcessos
            defaultValue={getValues("cliente")}
            defaultFiltroTipoClient={["A", "C", "E"]}
            onChange={(value: any) => {
              setValue("cliente", value);
              handleConfirm();
            }}
          />
        )}
        {modalContent === "criarAtualizacao" && (
          <Formulario {...{ handleClose, handleBack }} />
        )}
      </FormProvider>
    </Dialog>
  );
}

const itemsAtt = [
  {
    tipo: "Geral",
    limiteCredito: "R$750.000,00",
    vigencia: {
      inicio: moment(),
      fim: moment().add(1, "month"),
    },
    temContrato: "Sim",
    registrado: null,
    valorContrato: "",
    vencimentoContrato: null,
    garantias: [
      "Nota primissória",
      "Hipotecaria",
      "Pignoratícia",
      "Alienação fiduciária",
      "Outros",
    ],
    utilizadoLimite: "R$359.928,54",
    disponivel: "R$390.071,46",
  },
];

export const defaultValuesForm = {
  cliente: clienteDefValue,
  listaAttLimiteCredito: itemsAtt,
  formAttLimiteCredito: null,
};

interface DialogAtualizacaoLimitesProps {
  open: boolean;
  handleClose: () => void;
}

export interface ConfigLimiteCred {
  tipo: string;
  limiteCredito: string;
  vigencia: {
    inicio: Moment | null;
    fim: Moment | null;
  };
  temContrato: string;
  registrado: string | null;
  valorContrato: string;
  vencimentoContrato: Moment | null;
  garantias: string[];
}

export type TModalContent = "selecionarCliente" | "criarAtualizacao";
